/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { MAGNETIC_TOKENS, css } from '@appd/uik';

export const MedalCell = ({ count = 0, kind = (['Gold', 'Silver', 'Bronze', 'Total'] as const)[0 as number] }) => (
  <div
    className={css({
      display: 'flex',
      gap: MAGNETIC_TOKENS.SPACING[1],
      alignItems: 'center',
      font: MAGNETIC_TOKENS.TYPOGRAPHY.P3_BOLD,
      ...MAGNETIC_TOKENS.TYPOGRAPHY.ELLIPSES.END,
    })}
  >
    {kind !== 'Total' && (
      <div
        className={css({
          borderRadius: '50%',
          flexShrink: 0,
          width: 11,
          height: 11,
          backgroundColor: {
            Gold: '#FFE150',
            Silver: '#E5E5E5',
            Bronze: '#DCB386',
          }[kind],
        })}
      />
    )}
    {count || '-'}
  </div>
);
